import i18n from "../i18n";

const numberLocale = (): string => (i18n.language === "en" ? "en-US" : "vi-VN");

export const formatVnd = (value: number): string => `${(value || 0).toLocaleString(numberLocale())} đ`;

// Product prices are stored as "thousands" in the seed data (e.g. 35 -> 35,000 đ),
// matching how the catalogue (Menu) displays them. Keep card/listing prices consistent.
export const formatProductPrice = (value?: number | null): string =>
    `${((value || 0) * 1000).toLocaleString(numberLocale())} đ`;
